import React, { createContext, useContext, useEffect, useState } from "react";

const DICT = {
  id: {
    nav_home: "Beranda", nav_explore: "Jelajah", nav_whosgoing: "Siapa Berangkat?",
    nav_board: "Papan Request", nav_messages: "Pesan", nav_orders: "Pesanan",
    nav_profile: "Profil", nav_posttrip: "Buat Trip", nav_trips: "Trip Saya",
    nav_requests: "Request", nav_wallet: "Dompet", nav_admin: "Admin",
    login: "Masuk", register: "Daftar", logout: "Keluar",
    find_bawainer: "Cari BAWAINER", post_trip: "Posting Trip Kamu",
    request_item: "Request Barang", become_bawainer: "Jadi BAWAINER",
    hero_title: "Mau dari mana?",
    hero_sub: "Seseorang sedang ke sana. Kamu mau sesuatu dari sana. BAWAIN menghubungkan kalian.",
    search_ph: "Cari destinasi, produk, atau BAWAINER",
    whos_going: "SIAPA BERANGKAT?", going_this_month: "Berangkat bulan ini",
    bawainer_going: "BAWAINER berangkat", verified: "Terverifikasi",
    completed_trips: "trip selesai", response_rate: "tingkat respon",
    service_fee: "Biaya jasa", available_cap: "Kapasitas tersedia",
    accepted_cats: "Kategori diterima", departure: "Berangkat", ret: "Pulang",
    accept_pay: "Terima & Bayar", decline: "Tolak", ask_question: "Tanya Dulu",
    send_request: "Kirim Request", send_quotation: "Kirim Penawaran",
    confirm_received: "Konfirmasi Diterima", i_can_bring: "Saya Bisa Bawakan",
    post_request: "Posting Request", publish_trip: "Publikasikan Trip",
    available: "Tersedia", pending: "Tertahan", total_earned: "Total pendapatan",
    withdraw: "Tarik Dana", no_bawainer: "Belum ada BAWAINER ditemukan.",
    post_request_instead: "Posting Request Saja",
    loading: "Memuat...", categories: "Kategori", filters: "Filter",
    all_destinations: "Semua Destinasi", verified_only: "Hanya terverifikasi",
    save: "Simpan", cancel: "Batal",
  },
  en: {
    nav_home: "Home", nav_explore: "Explore", nav_whosgoing: "Who's Going?",
    nav_board: "Request Board", nav_messages: "Messages", nav_orders: "Orders",
    nav_profile: "Profile", nav_posttrip: "Post Trip", nav_trips: "My Trips",
    nav_requests: "Requests", nav_wallet: "Wallet", nav_admin: "Admin",
    login: "Log In", register: "Sign Up", logout: "Log Out",
    find_bawainer: "Find a BAWAINER", post_trip: "Post Your Trip",
    request_item: "Request an Item", become_bawainer: "Become a BAWAINER",
    hero_title: "Where from?",
    hero_sub: "Someone is going there. You want something from there. BAWAIN connects you.",
    search_ph: "Search destination, product, or BAWAINER",
    whos_going: "WHO'S GOING?", going_this_month: "Going this month",
    bawainer_going: "BAWAINER going", verified: "Verified",
    completed_trips: "completed trips", response_rate: "response rate",
    service_fee: "Service fee", available_cap: "Available capacity",
    accepted_cats: "Accepted categories", departure: "Departure", ret: "Return",
    accept_pay: "Accept & Pay", decline: "Decline", ask_question: "Ask a Question",
    send_request: "Send Request", send_quotation: "Send Quotation",
    confirm_received: "Confirm Received", i_can_bring: "I Can Bring This",
    post_request: "Post Request", publish_trip: "Publish Trip",
    available: "Available", pending: "Pending", total_earned: "Total earned",
    withdraw: "Withdraw", no_bawainer: "No BAWAINER found.",
    post_request_instead: "Post a Request Instead",
    loading: "Loading...", categories: "Categories", filters: "Filters",
    all_destinations: "All Destinations", verified_only: "Verified only",
    save: "Save", cancel: "Cancel",
  },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(localStorage.getItem("bawain_lang") || "id");
  useEffect(() => localStorage.setItem("bawain_lang", lang), [lang]);
  const t = (key) => DICT[lang][key] || DICT.en[key] || key;
  const toggle = () => setLang((l) => (l === "id" ? "en" : "id"));
  return <I18nContext.Provider value={{ lang, t, toggle, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
